<template>

    <modal :show="showModal">

        <div class="mma" v-show="!loading" ref="BODY">

            <img src="/img/newsletters-v2/x-blue.svg" class="img__20 mma__cancel" @click="close">

            <img :src="isBlocked ? '/img/newsletters-v2/illustration-rewind_auto-delete.svg' : '/img/newsletters-v2/illustration-rewind_keep.svg'" class="img__58">

            <p class="text-lSemibold mt__16">
                {{ isBlocked ? $tc('pop_up_rollback_autodelete_description', arrayItems.length) : this.$tc('pop_up_rollback_keep_description', arrayItems.length) }}</p>

            <button class="mma__cta mma__cta__blue mt__16 text-baseBold-2" @click="accept">{{isBlocked ? $t('cleaning_stop_delete') : $t('cleaning_stop_keep')}}</button>

            <button class="mma__cta mma__cta__white mt__8 text-baseBold-2" @click="close">{{$t('pop_up_delete_cta_cancel')}}</button>

        </div>

        <div class="mma_loader" :style="loaderStyle" v-show="loading">

            <lottie-loader></lottie-loader>

        </div>

    </modal>

</template>

<script>
import ENUM from '@/assets/ENUM'

import Api from '@/api'

import Tag from '@/modules/tag'

import Checkbox from '@/components/inputs/Checkbox'
import LottieLoader from '@/components/lottie/LottieLoader'
import Modal from '@/components/modal/Modal'

export default {

    name: 'modal-my-actions',

    components: {Checkbox, LottieLoader, Modal},

    props: {
        category: {
            type: String,
            default: ''
        },

        arrayItems: {
            type: Array,
            default: () => []
        }
    },

    computed: {

        isBlocked() {
            return this.category === ENUM.NEWSLETTERS.CATEGORIES.AUTO_DELETE
        },

        loaderStyle() {
            return `width: ${this.width}px; height: ${this.height}px`
        }
    },

    data() {
        return {
            showModal: false,
            loading: false,
            width: 0,
            height: 0
        }
    },

    methods: {

        open() {

            this.loading = false

            this.showModal = true

            this.category === ENUM.NEWSLETTERS.CATEGORIES.AUTO_DELETE
                ? Tag.popupAmplitude(this, 'pop_up_rollback_autodelete')
                : Tag.popupAmplitude(this, 'pop_up_rollback_keep')

            this.getSize()

        },

        getSize() {
            this.width = this.$refs.BODY.clientWidth
            this.height = this.$refs.BODY.clientHeight
        },

        close(bool) {
            this.showModal = false
            Tag.clickAmplitude(this, 'cancel')
            this.$emit('close', bool)
        },

        accept() {

            this.getSize()

            this.loading = true

            const request = this.category === ENUM.NEWSLETTERS.CATEGORIES.AUTO_DELETE
                ? Api.newsletters.unblock
                : Api.newsletters.release

            this.category === ENUM.NEWSLETTERS.CATEGORIES.AUTO_DELETE
                ? Tag.clickAmplitude(this, 'rollback_autodelete')
                : Tag.clickAmplitude(this, 'rollback_keep')

            request(this.arrayItems)
                .then(data => {
                    this.close(data.done)
                })
                .catch(() => {
                    this.close(false)
                })
                .finally(() => {
                    this.loading = false
                })
        }

    }

}

</script>

<style lang="scss" scoped>

.mma {
    padding: 44px 16px 24px;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 400px;

    &_loader {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    &__cancel {
        position: absolute;
        top: 24px;
        right: 16px;

        &:lang(ar-sa) {
            right: unset;
            left: 16px;
        }
    }

    &__cta {
        width: 100%;
        padding: 17px;
        border-radius: 72px;

        &__white {
            background-color: $white;
            border: solid 4px #e7e7e8;
        }

        &__blue {
            border: 4px solid $aquamarine;
            background-color: $aquamarine;
            color: $white;
        }
    }
}

</style>
